import type { TFunction } from 'i18next';
import { selectionCheckboxId } from '~/components/ui/selectionCheckbox';
import type {
  NegotiationSelection,
  NegotiationSelectionTarget,
} from './negotiationSelection';

export type NegotiationCellState = Readonly<{
  checkboxId: string;
  isSelected: boolean;
  isDisabled: boolean;
  tooltip: string | undefined;
  onToggle: () => void;
}>;

export function negotiationCellState({
  rowId,
  target,
  isPending,
  selection,
  t,
}: Readonly<{
  rowId: string;
  target: NegotiationSelectionTarget | undefined;
  isPending: boolean;
  selection: NegotiationSelection;
  t: TFunction;
}>): NegotiationCellState {
  const isSelected = target
    ? selection.selectedKeys.has(target.negotiationKey)
    : false;
  const isCurrencyMismatch =
    !isSelected &&
    selection.currency != null &&
    target != null &&
    target.currencyCode !== selection.currency;

  let tooltip: string | undefined;
  if (isPending) tooltip = t('order_builder.table.negotiation_pending_tooltip');
  else if (isCurrencyMismatch)
    tooltip = t('order_builder.table.negotiation_currency_mismatch_tooltip');

  return {
    checkboxId: selectionCheckboxId('negotiation', rowId),
    isSelected,
    isDisabled: !target || isCurrencyMismatch,
    tooltip,
    onToggle: () => {
      if (target) selection.onToggle(target);
    },
  };
}
